export const CART_ITEM_TYPE = {
  OFFERING: 'Offering',
  PRODUCT: 'Product',
  SERVICE: 'Service'
};
